export const accidentModalInputs = {
  gridKey: "grid_modal_body",
  blockVisibility: true,
  inputsOptions: {
    rejectReason: {
      key: "rejectReason",
      label: "Укажите причину прекращения дела:",
      type: "textarea",
      rows: 3,
      textarea: true,
      placeholder:
        "Укажите письмо, заключение, на основании которого дело прекращено, а также причину смерти (если таковая имеламесто)",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
    },
    deadAdult: {
      key: "deadAdult",
      label: "Количество погибших взрослых",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^[0-9]+$/,
        message: "Только цифры",
      },
    },
    deadChildren: {
      key: "deadChildren",
      label: "Количество погибших детей",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^[0-9]+$/,
        message: "Только цифры",
      },
    },
    deadDrunk: {
      key: "deadDrunk",
      label:
        "Количество погибших в состоянии алкогольного опьянения (в том числе)",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^[0-9]+$/,
        message: "Только цифры",
      },
    },
  },
};
